export const APIKEY_CREATION_REQUEST = "APIKEY_CREATION_REQUEST";
export const APIKEY_CREATION_SUCCESS = "APIKEY_CREATION_SUCCESS";
export const APIKEY_CREATION_FAIL = "APIKEY_CREATION_FAIL";
